<template>
    <div class="subNavbar">
        <div class="flex align-center margin-auto justify-center">
            <div class="subNavbarItem" v-for="(item,index) in list" :key="index" @click="handleClick(index,item)">{{item.title}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'subNavbar',
        data() {
            return {
                item:{}
            }
        },
        props:{
            list:{
                type:Array,
                default(){
                    return []
                }
            },
        },
        methods:{
            handleClick(index,item){
                // this.$nextTick(()=>{
                //     this.$refs.DOM.scrollTo(0,300)
                // })
                this.item=item
                this.$emit('click',index)
            },
            getItem(){
                return this.item
            }
        }
    }
</script>

<style lang="scss" scoped>
    .subNavbar{
        position: absolute;
        width: 100%;
        height: 60px;
        line-height: 60px;
        background:rgba(40,40,40,1);
        opacity:0.6;
        color:#fff;
        
    }
    .subNavbarItem{
        margin:0 15px;
        cursor: pointer;
        font-size: 13px;
        font-family: Alibaba Regular;
        color: #fff;
    }
</style>